var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.memoObj.viewBln,
      expression: "memoObj.viewBln"
    }],
    staticClass: "memoContainer",
    on: {
      "click": _vm.closeHandler
    }
  }, [_c('div', {
    ref: "memoWrap",
    staticClass: "memoWrap",
    style: _vm.posStyles
  }, [_vm.memoObj.text == '' ? _c('p', {
    staticClass: "placeholder"
  }, [_vm._v(_vm._s(_vm.memoObj.placeholder))]) : _vm._e(), _c('p', {
    ref: "memoWrite",
    staticClass: "memoWrite",
    attrs: {
      "contenteditable": "true",
      "spellcheck": "false",
      "value": _vm.memoObj.text
    },
    on: {
      "input": _vm.inputHandler
    }
  })])]);

}
var staticRenderFns = []

export { render, staticRenderFns }